import React from "react";
import { Link, useLocation } from "react-router-dom"; 

// 1. Added inline SVGs for a sleek collapsed state
const sidebarItems = [
  { 
    name: "Dashboard", 
    path: "/dashboard",
    icon: <svg className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>
  },
  { 
    name: "Free Quantity Report", 
    path: "/reports/free-quantity",
    icon: <svg className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
  },
  { 
    name: "Party Wise Product", 
    path: "/reports/Customer-wise",
    icon: <svg className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
  },
  // { 
  //   name: "Profitability Report", 
  //   path: "/reports/Product-Profitability",
  //   icon: <svg className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
  // },
  { 
    name: "Party Profile Report", 
    path: "/reports/Customer-Profile",
    icon: <svg className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
  },
  { 
    name: "Season Wise Sales", 
    path: "/reports/Season-Wise-Transaction",
    icon: <svg className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
  },
  { 
    name: "National Stock Report", 
    path: "/reports/Central-Location-Stock",
    icon: <svg className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>
  },
];

const Sidebar = ({ onLogout }) => {
  // 2. Added useLocation to track the active route
  const location = useLocation();

  return (
    <aside className="
      h-screen 
      bg-slate-900 
      text-slate-300 
      hidden 
      md:flex 
      flex-col 
      w-20 
      hover:w-[280px] 
      transition-all 
      duration-300 
      ease-in-out
      group
      border-r border-slate-800" 
    >
      
      {/* BRANDING HEADER */}
      <div className="flex items-center h-20 px-6 border-b border-slate-800">
        {/* Logo Mark for collapsed state */}
        <div className="flex items-center justify-center min-w-[32px] h-8 bg-indigo-600 rounded-lg text-white font-bold tracking-wider">
          KB
        </div>
        {/* Full Title for expanded state */}
        <div className="ml-4 text-xl font-bold text-white whitespace-nowrap 
          opacity-0 
          group-hover:opacity-100 
          transition-opacity 
          duration-300">
          Krishok Bondhu
        </div>
      </div>

      {/* NAVIGATION LINKS */}
      <div className="flex-1 overflow-y-auto py-6 scrollbar-hide">
        <nav>
          <ul className="space-y-2 px-3">
            {sidebarItems.map((item) => {
              // 3. Determine if this link is the currently active page
              const isActive = location.pathname === item.path;

              return (
                <li key={item.name}>
                  <Link 
                    to={item.path} 
                    className={`flex items-center px-3 py-3 rounded-xl transition-all duration-200 group/link
                      ${isActive 
                        ? "bg-indigo-600 text-white shadow-md" 
                        : "hover:bg-slate-800 hover:text-white"
                      }`}
                  >
                    {/* Icon container */}
                    <div className={`flex items-center justify-center w-8 h-8 rounded-lg 
                      ${isActive ? "text-white" : "text-slate-400 group-hover/link:text-white"}`}>
                      {item.icon}
                    </div>
                    
                    {/* Item Text */}
                    <span className="
                        ml-4
                        font-medium
                        text-sm
                        whitespace-nowrap
                        opacity-0 
                        translate-x-[-10px]
                        group-hover:translate-x-0
                        group-hover:opacity-100 
                        transition-all 
                        duration-300">
                        {item.name}
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>

      {/* LOGOUT BUTTON */}
      <div className="p-4 border-t border-slate-800">
        <button
          onClick={onLogout}
          className="flex items-center w-full px-3 py-3 text-red-400 rounded-xl hover:bg-red-500/10 hover:text-red-500 transition-colors"
        >
          {/* Logout Icon */}
          <div className="flex items-center justify-center w-8 h-8">
             <svg className="w-6 h-6 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
          </div>
          
          {/* Logout Text */}
          <span className="
            ml-4
            font-medium
            text-sm
            whitespace-nowrap
            opacity-0 
            group-hover:opacity-100 
            transition-opacity 
            duration-300">
            Logout
          </span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;